import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
// import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../../services/data.service';
import { OrgFormComponent } from '../org-form/org-form.component';
import { OrgViewComponent } from '../org-view/org-view.component';

@Component({
	selector: 'app-org-list',
	imports: [CommonModule, FormsModule, OrgFormComponent, OrgViewComponent],
	templateUrl: './org-list.component.html',
	styleUrl: './org-list.component.scss',
})
export class OrgListComponent {
  @Input() user: any;
  @Input() action: any;
  
  base = 'organizations';		// important for API calls

  loading = false;
  btnClick: string = "";
  searchTerm: string = '';
  isEdit = false;
  headers: any = null;
	allData: any = [];
  orgData: any = [];
  spTitle: string = '';
  spType: string = '';    //address / contact
  spOpt: string = 'list';   // list, add, edit
  addresses: any = [1,2,3,4,5,6,7,8,9,0];
  selOrg: any = {};
  
  constructor(
    // private router: Router, 
    public dataService: DataService
  ) {
    //
  }

  ngOnInit() {
    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem && !this.user) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;
    }

		this.loading = true;
    this.dataService.getAllRecords('orgz-inst-only').then((res: any) => {
      if(res && res.length) {
        this.allData = res;
        this.orgData = Object.assign([], res);    //keep it for safety - original data
        // console.log(this.allData);

        for(let j=0; j<this.allData.length; j++) {
          let instData: any = this.allData[j].institutes;

          if(instData && instData.length) {
            for(let i=0; i<instData.length; i++) {
              const curDate: Date = new Date();
              const expDate: Date = new Date(instData[i].exp_date);
              const dayRemains = this.dataService.getDaysDiff(curDate, expDate);
              instData[i].dayRemains = dayRemains;

              if(dayRemains < 15) {
                instData[i].reNewAlert = true;
              } else {
                instData[i].reNewAlert = false;
              }
            }
          }

        }
      }
      this.loading = false;
    });
	}

	ngOnChanges() {
		if(this.action && this.action=='reload') {
			this.ngOnInit();
		}
	}

  orgConnect(org: any) {
    this.selOrg = org;

  }

  addressBook(org_id: number) {
    this.spType = 'address';
    this.spTitle = 'Address';
  }

  contactBook(org_id: number) {
    this.spType = 'contact';
    this.spTitle = 'Contact';
  }

  newClick() {
    this.isEdit = false;
    this.btnClick = 'addnew';
    this.dataService.updateOuterAction({
      component: 'organization',
      action: 'addnew', data: null
    });
  }

  editClick(myData: any) {
    this.isEdit = true;
    this.btnClick = 'modify';
    this.dataService.updateOuterAction({
      component: 'organization',
      action: 'edit', data: myData
    });
  }

  reloadData() {
    setTimeout(()=>{
      this.ngOnInit();
    }, 1000);
  }

//   searchAnyField() {
//     const searchTerm: any = this.kw4search;
//     const array = Object.assign([], this.orgData);
//     // Convert search term to string and lowercase for case-insensitive matching
//     const query = String(searchTerm).toLowerCase();

//     this.allData = array.filter((item: any) => {
//       // Extract all property values of the current object
//       const values = Object.values(item);

//       // Check if at least one value matches the search query
//       return values.some(val => 
//         String(val).toLowerCase().includes(query)
//       );
//     });
//   }

  onSearchChange(): void {
    const query = this.searchTerm.trim().toLowerCase();

    if (!query) {
      this.allData = [...this.orgData];
      return;
    }

    this.allData = this.orgData.filter((user: any) => this.deepMatch(user, query));
  }

  private deepMatch(value: any, query: string): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    if (typeof value === 'object') {
      return Object.values(value).some(nestedValue => this.deepMatch(nestedValue, query));
    }

    return String(value).toLowerCase().includes(query);
  }
  
	async deleteClick(myid: number) {
    const confirmed = await this.dataService.confirmDelete();
    if (confirmed) {
        console.log('Item deleted successfully');
				this.doDelete(myid);
    } else {
        console.log('Deletion cancelled');
    }
	}

  doDelete(myid: number) {
		this.loading = true;
    this.dataService.deleteRecord(this.base, myid).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
        this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
	}

}
